import { render, staticRenderFns } from "./CartParentRouter.vue?vue&type=template&id=2dce2766"
import script from "./CartParentRouter.vue?vue&type=script&lang=js"
export * from "./CartParentRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports